import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="py-6 container">
        <div className="steps mt-6 mb-4 hide-on-tablet">
          <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
            <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">1</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Add Your Allocation</div>
                  <div className="ant-steps-item-description">Enter your token to be send with allocations </div>
                </div>
              </div>
            </div>
            <div className="ant-steps-item ant-steps-item-wait">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">2</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Confirmation</div>
                  <div className="ant-steps-item-description">Let review your information</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ant-card ant-card-bordered">
          <div className="ant-card-body">
            <form>
              <div className="field"><label className="label" for="tokenAddress">Token address</label>
                <div className="control"><input className="input" type="text" placeholder="Ex: 0x..." id="tokenAddress" name="tokenAddress" value="" />
                  <p className="help is-info">Pink Multi-sender allows you to send ERC20 token in batch by easiest way. You can enter token address to send specific token or leave it blank to send chain token such as BNB....</p>
                </div>
              </div>
              <div className="field"><label className="label" for="recipients">Allocations<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><textarea className="textarea" name="recipients" id="recipients" rows="10" placeholder="Insert allocation: separate with breaks line. By format: address,amount or address amount
Ex:
0x0000000000000000000000000000000000001000 13.45
0x0000000000000000000000000000000000001000 1.049
0x0000000000000000000000000000000000001000 1"></textarea></div>
                <div className="ant-space ant-space-horizontal ant-space-align-center" style={{ gap: "8px" }}>
                  <div className="ant-space-item"><label className="my-2 ant-btn ant-btn-default">
                    <div>Or choose from CSV file</div><input hidden="true" type="file" />
                  </label></div>
                  <div className="ant-space-item">
                    <div className="has-text-primary is-clickable is-size-7">Sample CSV file
                    </div>
                  </div>
                </div>
              </div>
              <div data-show="true" className="ant-alert ant-alert-warning ant-alert-no-icon mb-2" role="alert">
                <div className="ant-alert-content">
                  <div className="ant-alert-message">
                    <article className="ant-typography">Please exclude <span className="ant-typography"><strong>0x5D00661EA3c9b8f095520573b9B940B6fEbcfD8b</strong>
                      <div role="button" tabindex="0" className="ant-typography-copy"
                        aria-label="Copy"
                        style={{ border: "0px", background: "transparent", padding: "0px", lineHeight: "inherit", display: "inline-block" }}>
                        <span role="img" aria-label="copy"
                          className="anticon anticon-copy"><svg
                            viewBox="64 64 896 896" focusable="false"
                            data-icon="copy" width="1em" height="1em"
                            fill="currentColor" aria-hidden="true">
                            <path
                              d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z">
                            </path>
                          </svg></span>
                      </div>
                    </span> from fees, rewards, max tx amount to start sending tokens.
                    </article>
                  </div>
                  <div className="ant-alert-description"></div>
                </div>
              </div>
              <div className="has-text-centered"><button type="submit" className="ant-btn ant-btn-primary" disabled=""><span>Next</span></button></div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
